/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S5_HeadingInputs */

const tr_kullanim_s5_heading = /** @type {(inputs: Kullanim_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Yetki ve Uygulanacak Hukuk`)
};

const en_kullanim_s5_heading = /** @type {(inputs: Kullanim_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Jurisdiction and applicable law`)
};

const de_kullanim_s5_heading = /** @type {(inputs: Kullanim_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Gerichtsstand und anwendbares Recht`)
};

const ru_kullanim_s5_heading = /** @type {(inputs: Kullanim_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Подсудность и применимое право`)
};

/**
* | output |
* | --- |
* | "5. Jurisdiction and applicable law" |
*
* @param {Kullanim_S5_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s5_heading = /** @type {((inputs?: Kullanim_S5_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S5_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s5_heading(inputs)
	if (locale === "de") return de_kullanim_s5_heading(inputs)
	if (locale === "ru") return ru_kullanim_s5_heading(inputs)
	return tr_kullanim_s5_heading(inputs)
});